<template>
    <div>
        <div class="row" id="campaigns-stats">
            <div class="col-md-12">
                <div class="campaign-box campaign-box--no_border">
                    <div class="campaign-details-chart-title">
                        <div class="campaign-details-subtitle">
                            Deposits Reporting
                            <info-tooltip
                                    text="View your amount spent across all campaigns for the selected date range."></info-tooltip>
                        </div>
                    </div>

                    <div class="row" v-if="loadingLooker">
                        <div class="col-md-12 text-center campaigns-summary--loading">
                            <i class="fa fa-spinner fa-spin inner-loading"></i>
                        </div>
                    </div>

                    <div class="row campaign-stats-chart"
                         :style="loadingLooker ? 'visibility: hidden; position: absolute' : ''">
                        <div class="col-xs-12 campaign-metrics_div" v-cloak>
                            <div class="col-xs-12">
                                <div>
                                    <p>View your amount spent across all campaigns for the selected date range.</p>
                                </div>

                                <div>
                                    <div class="row">
                                        <div class="col-sm-5">
                                            <span class="datepicker-label">Date range</span>
                                            <looker-date-range-picker
                                                v-model="dateRange"
                                            ></looker-date-range-picker>
                                        </div>

                                        <div class="col-sm-5">
                                            <span class="datepicker-label">Product Type</span>
                                            <multiselect
                                                :options="dimensions.loan_purposes"
                                                v-model="selectedProductType"
                                                label="label"
                                                track-by="id"
                                                :searchable="true"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :show-labels="false"
                                                placeholder="All Product Types"
                                            ></multiselect>
                                        </div>
                                    </div>

                                    <hr>

                                    <looker-embed
                                        :embedUrl="embedUrl"
                                        :filters="lookerQueryFilters"
                                        :dateRangeString="dateRangeString"
                                        :height="height"
                                    ></looker-embed>
                                </div>
                            </div>
                        </div>
                    </div>
                    <disclaimer class="m-t-lg"></disclaimer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    props: ['embedUrl'],

    data() {
        return {
            vertical: 'deposits',
            height: '800px',
            dimensions: {
                loan_purposes: [
                    {'id': 'Checking', 'label': 'Checking' },
                    {'id': 'CDs', 'label': 'Certificate of Deposit' },
                    {'id': 'Savings', 'label': 'Savings' },
                    {'id': 'MMA', 'label': 'Money Market Account' }
                ]
            },
            selectedProductType: [],
            dateRange: null
        }
    },

    computed: {
        dateRangeString() {
            if (!this.dateRange) return null;

            const adjustedEndDate = this.dateRange.end.clone().add(1, 'd');

            return `${this.dateRange.start.format('YYYY/MM/DD')} to ${adjustedEndDate.format('YYYY/MM/DD')}`;
        },

        loadingLooker() {
            return this.totalSpent === null;
        },

        lookerQueryFilters() {
            return {
                "Product": _.map(this.selectedProductType, productType => {
                    return productType.id;
                }).join(',')
            };
        }
    },

    components: {
        Multiselect
    }
}
</script>
